import { Icon } from "../../ui/icons.js";

/**
 * The one press that fills an empty **Set up** from the business page (`outreach_setup`).
 *
 * It only ever fills what is empty, which is the whole of why it is safe to press twice: asking again after
 * editing a table does not throw the table away.
 */

/** Before anything has been written: the one button that reads the business page and proposes the lot. */
export function FirstDraft({ draft, busy, error, mayEdit, priceUsd }: { draft: () => void; busy: boolean; error: unknown; mayEdit: boolean; priceUsd: string | null }) {
  return (
    <div className="rounded-xl border border-line bg-panel p-4 flex flex-col gap-3">
      <h2 className="text-sm font-semibold">Start from your business page</h2>
      <p className="text-[13px] leading-relaxed text-ink-2">
        Joogoos can read what you have already written about your business and propose who to look for, what makes one
        worth writing to, and what to offer them. Every line of it is yours to change afterwards, and nothing is
        searched for or sent until you say so.
      </p>
      <div className="flex items-center gap-3">
        <button onClick={draft} disabled={busy || !mayEdit} className="px-3 py-2 rounded-lg bg-ink text-white text-sm font-semibold flex items-center gap-2 disabled:opacity-40">
          <Icon name="wand" size={14} /> {busy ? "Reading your page…" : "Write the first draft"}
        </button>
        {/* The price the server works out for this page, never a figure of the screen's own (`SetupResponse.draftUsd`). */}
        {priceUsd ? <span className="text-xs text-muted">about {cents(priceUsd)}</span> : null}
      </div>
      {!mayEdit ? <p className="text-xs text-muted">Only an owner of this workspace can set this up.</p> : null}
      {error ? <p className="text-xs text-bad">{String(error)}</p> : null}
    </div>
  );
}

/** A price under a dollar in cents, rounded up so it is never less than what is charged: "about 5¢". */
const cents = (usd: string) => (Number(usd) < 1 ? `${Math.max(1, Math.ceil(Number(usd) * 100))}¢` : `$${Number(usd).toFixed(2)}`);
